(function(angular, module) {var newChangeLogController, stateConfig;

newChangeLogController = function(ChangeLogService, authors, moment, $q, Principal) {
  'ngInject';
  this.authors = authors;
  this.scopeOptions = ChangeLogService.scopeOptions;
  this.data = {
    author_id: parseInt(Principal.id),
    scope: 'everyone',
    published: moment()
  };
  this.save = function(data) {
    return ChangeLogService.create(data);
  };
};

stateConfig = function($stateProvider) {
  'ngInject';
  $stateProvider.state('changeLog.new', {
    url: '/new',
    templateUrl: 'changeLog/new',
    controller: newChangeLogController,
    controllerAs: 'ctrl',
    resolve: {
      authors: function(ChangeLogService) {
        'ngInject';
        return ChangeLogService.getAuthors();
      }
    }
  });
};

module.config(stateConfig);
})(angular, angular.module("changeLog"));